const ProgressBar = ({ progress, height }) => {
    return (
        <div className={`w-full h-${height? height : 4} bg-gray-200 rounded-full dark:bg-gray-700`}>
            <div
                className={`h-${height? height : 4} rounded-full dark:bg-blue-500 bg-yellow`}
                style={{ width: `${progress}%` }}
            ></div>
        </div>
    );
};

export default ProgressBar;